module.exports = __webpack_public_path__ + "static/img/pos_order_list2.98c794a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_order_list2.png
// module id = lg5T
// module chunks = 8